import Aos from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
const ServiceCard = ({ sCard }) => {
  const { icon, description, title } = sCard;

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div data-aos-easing="fade-up" className="card w-96 bg-base-100 shadow-xl">
      <figure className="px-10 pt-10">
        <img src={icon} alt="icons" className="rounded-xl" />
      </figure>
      <div className="card-body items-center text-center">
        <h2 className="card-title">{title}</h2>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
